import ICCardList from './ICCardList';

export default ICCardList;
